var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"context-button"},[_c('idf-pictogram',{attrs:{"icon":"three-dots-vertical"},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }